import isPropValid from '@emotion/is-prop-valid';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import IcClose from 'src/assets/images/icClose.svg';
import IcInventory from 'src/assets/images/icInventoryFill.svg';
import Button from 'src/components/Button';

export const GlobalStyle = css`
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
  html,
  body {
    overscroll-behavior: none;
  }
`;

export const FooterButtonBase = styled(Button)<{ backgroundColor?: string }>`
  font-family: var(--font-noto-sans);
  color: ${({ theme }) => theme.color.contentDeep};
  max-height: 48px;
  ${({ backgroundColor, theme }) =>
    backgroundColor &&
    `
    ${theme.pointer.mouse} {
      &, &:not([disabled]):hover {
        background-color: ${backgroundColor};
      }
    }
  `}
`;

export const FooterAnchorInline = styled.a`
  text-decoration: none;
  display: flex;
`;

export const FooterAnchor = styled(FooterAnchorInline)`
  flex-grow: 1;
`;

export const ShareButton = styled.button`
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  background-color: ${({ theme }) => theme.color.surface11};
  border-radius: 56px;
  background-image: url('/images/event/icShare.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px 24px;
`;

export const Root = styled.div`
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  text-align: center;
`;

export const ImageWrap = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ImageText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 78px;
  padding: 0 24px;
  position: absolute;
`;

export const Image = styled.div`
  width: 100%;
  height: 380px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const Title = styled.div`
  font-size: 30px;
  font-weight: bold;
  line-height: 40px;
  color: ${({ theme }) => theme.color.contentDeep};
`;

export const Subtitle = styled.div`
  font-size: 20px;
  line-height: 30px;
  color: ${({ theme }) => theme.color.contentDeep};
`;

export const Section = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  > * + * {
    margin-top: 16px;
  }
`;

export const SectionImage = styled.img`
  width: 180px;
  height: 180px;
`;

export const SectionTitle = styled.div`
  font-family: var(--font-noto-sans);
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: ${({ theme }) => theme.color.contentDeep};
`;

export const SectionSubtitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: ${({ theme }) => theme.color.contentDeep};
`;

export const SectionDesc = styled.div`
  line-height: 17px;
  font-size: 14px;
  font-family: var(--font-noto-sans);
  color: ${({ theme }) => theme.color.content9};
`;

export const SectionDate = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
`;

export const SectionDateTime = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.color.content9};
`;

export const SectionDateBar = styled.div`
  width: 59px;
  height: 1px;
  background-color: ${({ theme }) => theme.color.surface9};
  margin: 0 16px;
`;

export const SectionDateText = styled.div`
  font-family: var(--font-noto-sans);
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.color.contentDeep};
`;

export const SectionDateWrap = styled.div``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
export const Footer = styled.div`
  padding: 16px 24px 24px 24px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  position: fixed;
  bottom: 0;
  left: 0;
`;

export const SectionReward = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SectionRewardRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
`;

export const SectionRewardIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-bottom: 3px;
`;

export const SectionRewardNameBase = styled.div<{ color?: string }>`
  font-family: var(--font-noto-sans);
  font-size: 14px;
  font-weight: 700;
  display: inline-flex;
  ${({ color }) =>
    color &&
    `
    color: ${color};
  `}
`;

export const Header = styled.div<{
  isTop: boolean;
  isAndroid: boolean;
  backgroundColor: string;
  scrollBackgroundColor: string;
}>`
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: ${({ isAndroid }) => (isAndroid ? '50px' : '44px')};
  padding: ${({ isAndroid }) => (isAndroid ? '6px 6px 0px' : '0px 6px')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ isTop, backgroundColor, scrollBackgroundColor }) =>
    isTop ? backgroundColor : scrollBackgroundColor};
`;

export const HeaderTitle = styled.div<{
  isShow: boolean;
  color: string;
}>`
  flex-grow: 1;
  text-align: start;
  font-size: 20px;
  font-weight: 700;
  color: ${({ color }) => color};
  visibility: ${({ isShow }) => (isShow ? 'visible' : 'hidden')};
`;

export const HeaderIconCss = ({
  isTop,
  color,
  scrollColor,
}: {
  isTop: boolean;
  color: string;
  scrollColor: string;
}) => css`
  width: 24px;
  height: 24px;
  color: ${isTop ? color : scrollColor};
`;

export const IconClose = styled(IcClose, {
  shouldForwardProp: isPropValid,
})<{
  isTop: boolean;
  color: string;
  scrollColor: string;
}>`
  ${HeaderIconCss}
`;

export const IconInventory = styled(IcInventory, {
  shouldForwardProp: isPropValid,
})<{
  isTop: boolean;
  color: string;
  scrollColor: string;
}>`
  ${HeaderIconCss}
`;

export const HeaderButton = styled.button`
  position: relative;
  width: 44px;
  height: 44px;
  padding: 10px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
`;
